export default __webpack_public_path__ + "static/media/Avatar-1.5d543cf6.png";